import { Theme } from "@mui/material";
import { getColors } from "../../../../../utils";
import { DARK } from "../../../../../constants";

export const STICKY_HEADER_HEIGHT = 50;

export const modalSx = {
  position: "fixed",
  top: "5vh",
  left: "50%",
  transform: "translateX(-50%)",
  width: "92vw",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  overflow: "hidden",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  height: "90dvh",
  maxHeight: "90dvh",
  border: getColors().border,
  maxWidth: 400,
};

export const scrollAreaSx = {
  flex: 1,
  overflowY: "auto",
  WebkitOverflowScrolling: "touch",
};

export const closeButtonSx = (theme, showStickyHeader: boolean) => ({
  position: "absolute",
  top: 12,
  right: 12,
  zIndex: 3,
  color: getColors().text,
  width: 28,
  height: 28,
  bgcolor: showStickyHeader ? "transparent" : getColors().bgwhite,
  border:
    showStickyHeader || theme.palette.mode !== DARK
      ? "none"
      : getColors().border,
  boxShadow: showStickyHeader ? 0 : 1,
});

export const stickyHeaderSx = {
  height: STICKY_HEADER_HEIGHT,
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  backgroundColor: "background.paper",
  display: "flex",
  gap: 2,
  alignItems: "center",
  px: 2,
  borderBottom: "1px solid",
  borderColor: "divider",
  borderTopLeftRadius: 1,
  borderTopRightRadius: 1,
  zIndex: 2,
};

export const footerSx = {
  borderTop: "1px solid",
  borderColor: "divider",
  p: 4,
  display: "flex",
  gap: 4,
  alignItems: "center",
};

export const IMAGE_HEIGHT = 300;

export const imageSx = (theme: Theme, image: string | undefined) => ({
  backgroundColor: "#F0F0F0",
  height: IMAGE_HEIGHT,
  backgroundImage: image ? `url(${image})` : "none",
  backgroundSize: "cover",
  backgroundPosition: "center",
  transition: "opacity 0.12s linear",
  flexShrink: 0,
  willChange: "opacity",
});
